import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '../api';

/**
 * Default values matching the settings registry.
 * Used as fallback when the API hasn't responded yet.
 */
const DEFAULTS: Record<string, unknown> = {
  'general.defaultPageSize': 50,
  'general.dashboardRecentItems': 5,
  'projects.historyPageSize': 10,
  'projects.exportFilenameTemplate': '{clientCode}-{projectName}',
  'catalog.versionsPageSize': 20,
  'catalog.confirmBeforePublish': true,
};

/**
 * Hook to access public settings (available to all authenticated users).
 * Returns setting values with type-safe getter, with defaults as fallback.
 */
export function usePublicSettings() {
  const { data } = useQuery({
    queryKey: ['settings', 'public'],
    queryFn: async () => {
      const res = await settingsApi.getPublic();
      return res.data.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });

  function get<T>(key: string): T {
    if (data && key in data) return data[key] as T;
    return DEFAULTS[key] as T;
  }

  return { get, settings: data ?? DEFAULTS };
}
